export const PANEL_HEADER_HEIGHT = 40;
export const PANEL_FOOTER_HEIGHT = 40;
//# sourceMappingURL=constants.js.map